import { init } from "../init-streaming";
import { TryPage } from "../pages/try/try-page";
init(TryPage);
